<template>
  <div id="contenedor-agregar-concepto-catalogo">
    <v-form
      v-model="formularioValido"
      ref="agregarConceptoCatalogo">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar {{getTipo()}}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              cols="12"
              md="12"
              class="py-1"
              v-model="concepto.clave"
              label="Clave"
              :rules="[mixReglas.requerido]"
              @blur="cargarConceptoSimilar"
              >
            </custom-text-field>
            <custom-text-area
              cols="12"
              md="12"
              class="py-1"
              v-model="concepto.concepto"
              label="Concepto"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-area>
            <v-row
              v-if="tipoConcepto.tipo > 1">
            <custom-text-field
              cols="12"
              md="6"
              class="py-1"
              v-model="concepto.unidad"
              label="Unidad"
              >
            </custom-text-field>
            <custom-text-field
              cols="12"
              md="6"
              v-model.number="concepto.cantidad"
              label="Cantidad"
              type="number"
              >
            </custom-text-field>
            <custom-text-field
              cols="12"
              class="pb-1"
              md="6"
              v-model.number="concepto.precioUnitario"
              label="Precio Unitartio"
              type="number"
              prefix="$"
              >
            </custom-text-field>
            </v-row>
            <!-- <custom-text-field
              cols="12"
              class="py-1"
              v-model="concepto.importe"
              label="Importe"
              prefix="$"
              type="number"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field> -->
            <!-- <custom-text-field
              cols="12"
              md="6"
              v-model.number="concepto.orden"
              label="Orden"
              type="number"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field> -->
            <custom-text-field
              cols="12"
              md="4"
              v-model.number="concepto.orden"
              label="Orden"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarCatalogoConcepto"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Agregar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogo from './mixCatalogo';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
// import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'AgregarConceptoCatalogoContrato',
  mixins: [mixCatalogo],
  props: {
    // catalogoConceptoEditar: {
    //   type: Object,
    //   required: true,
    // },
    tipoConcepto: {
      type: Object,
      required: true,
    },
    catalogo: {
      type: Array,
      required: false,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
    CustomTextArea,
    // CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      concepto: {
        tipo: this.tipoConcepto.tipo,
        idContrato: this.tipoConcepto.idContrato,
        idPadre: this.tipoConcepto.idPadre,
        clave: '',
        concepto: '',
        unidad: '',
        cantidad: 0,
        precioUnitario: 0,
        importe: 0,
        orden: 0,
      },
    };
  },
  methods: {
    getTipo() {
      switch (this.tipoConcepto.tipo) {
        case 0:
          return 'Partida';
        case 1:
          return 'Subpartida';
        case 2:
          return 'Concepto';
        default:
          return 'Partida';
      }
    },
    setImporte() {
      const { cantidad, precioUnitario } = this.concepto;
      this.concepto.importe = cantidad * precioUnitario;
    },
    cargarConceptoSimilar() {
      this.setOrden();
      if (this.concepto.tipo !== 2) return;
      const concepto = this.catalogo
        .find(({ clave }) => clave.toLowerCase() === this.concepto.clave.toLowerCase());
      if (concepto) {
        this.concepto.concepto = concepto?.concepto;
        this.concepto.unidad = concepto?.unidad;
        this.concepto.cantidad = concepto?.cantidad;
        this.concepto.precioUnitario = concepto?.precioUnitario;
        this.concepto.importe = concepto?.importe;
      }
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    cantidad() {
      return this.concepto.cantidad;
    },
    precioUnitario() {
      return this.concepto.precioUnitario;
    },
  },
  watch: {
    cantidad() {
      this.setImporte();
    },
    precioUnitario() {
      this.setImporte();
    },
  },

};
</script>

<style>

</style>
